/* eslint-disable */
import {
  Autocomplete,
  Avatar,
  Button,
  Group,
  MantineColor,
  Modal,
  MultiSelect,
  Select,
  SelectItemProps,
  Text,
} from "@mantine/core";
import UpdateLeaveConfigurationForm from "./leaveConfigAddForm";
// import AddLeaveRequestForm from "./leaveForm";
// import AddLeaveRequestForm from "./addLeaveForm";

type Props = {
  opened: boolean;
  onClose: () => void;
  selectedLeaveKey?: string | null;
  orgId?: string;
  configLevel?: string;
  entityId?: string;
  configYear?: number;
};

export default function UpdateLeaveConfigModal({
  opened,
  onClose,
  selectedLeaveKey = null,
  orgId,
  configLevel,
  entityId,
  configYear,
}: Props) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Update Leave Config${configLevel && configLevel !== "organization" ? ` (${configLevel} level)` : ""}${configYear ? ` — ${configYear}` : ""}`}
      size="md"
      centered
    >
      <UpdateLeaveConfigurationForm
        onClose={onClose}
        orgId={orgId}
        selectedLeaveKey={selectedLeaveKey}
        configLevel={configLevel}
        entityId={entityId}
        configYear={configYear}
      />
    </Modal>
  );
}
